
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 178 56"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.3 51.5a3.8 3.8 0 01-4 4H4.7c-1.1 0-2-.4-2.8-1.1-.7-.8-1-1.7-1-2.9V4.3c0-1.1.3-2 1-2.8.8-.7 1.7-1 2.8-1h14.6a4 4 0 012.9 1c.7.8 1.1 1.7 1.1 2.8v47.2zm-4.9-.4V4.7H5.7v46.4h12.7zm19.2 4.4h-5V17.3h-2v-.2l3-16.7h4v55zM51 31.7h-5.4v-6.2H51v6.2zm0 23.8h-5.4v-6.2H51v6.2zm28.1 0H57.3v-2.6l16.8-35V4.8H63V17h-5V4.3c0-1.1.4-2 1.1-2.8.7-.7 1.7-1 2.8-1h13.3c1.1 0 2 .3 2.8 1 .7.8 1 1.7 1 2.8V16c0 1.4-.4 3-1.2 4.8L63.2 51.1h16v4.4zm29.6-4c0 1.2-.3 2.1-1 2.8-.8.8-1.7 1.1-2.9 1.1H90.7c-1.2 0-2.1-.3-2.8-1-.8-.8-1.1-1.7-1.1-2.9v-14h4.9v13.6h12.1V34.3L94.1 27v-1l9.6-7.3v-14h-12v12.4h-4.9V4.3c0-1.1.4-2 1.1-2.8.7-.7 1.7-1 2.8-1h14c1.2 0 2.2.3 2.9 1 .7.8 1 1.7 1 2.8v13.4c0 1.8-.6 3.1-2 4.1l-6.6 4.6 6.6 4.6c1.4 1 2.1 2.4 2.1 4.2v16.3zm12.7-19.8H116v-6.2h5.4v6.2zm0 23.8H116v-6.2h5.4v6.2zm29.1-14.4h-4.1v14.3h-4.7V41.1h-15.5v-2.5L139.5.4h4.6v.2L131.5 37h10.2V17h4.7v20h4.1v4zm27.3 10.4c0 1.2-.3 2.1-1 2.8-.8.8-1.7 1.1-2.9 1.1h-13.5c-1.2 0-2.1-.3-2.8-1-.7-.8-1-1.7-1-2.9v-14h4.8v13.6H173V25.2h-16.2l.6-24.8h20.1v4.3h-15.3l-.6 16.2H174c1.2 0 2.1.3 2.8 1 .8.8 1.1 1.7 1.1 2.9v26.7z"}})])
          )
        }
      }
    